<template lang='pug'>
.popup-buttons(
  :class="isPopup ? 'popup-buttons--toBottom' : 'popup-buttons--normal2'")
    button.popup-button(@click='cancel') 取消
    button.popup-button(:class='submitButtonClass' @click='submit') 確定
</template>
<script>
export default {
  props: {
    isPopup: Boolean
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    submitButtonClass() {
      return this.isActive ? 'popup-button--active' : 'popup-button--inactive'
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    submit() {
      this.$emit('submit')
    },
    active() {
      this.isActive = true
    },
    inactive() {
      this.isActive = false
    }
  }
}
</script>
